import _ from "lodash";
import ExpectedProp from "../util/expected-prop";
import Immerable from "./immerable";

export class Labeling extends Immerable {
    public readonly udi: string | null;
    public readonly manufacturer: string;
    public readonly manufacturerModelName: string;
    public readonly systemVersion: string;
    public readonly description: string;
    public readonly labelingObject: any;
    public readonly labelingAsString: string;

    constructor(
        udi: string | null,
        manufacturer: string,
        manufacturerModelName: string,
        systemVersion: string,
        description: string,
        labelingObject: any,
    ) {

        super();

        this.udi = udi;
        this.manufacturer = manufacturer;
        this.manufacturerModelName = manufacturerModelName;
        this.systemVersion = systemVersion;
        this.description = description;
        this.labelingObject = labelingObject;

        this.labelingAsString = Object.keys(labelingObject).map((key) => `${key}: ${labelingObject[key]}`).join('\n');
    }
}

const expectedLabelingProps = [
    new ExpectedProp('manufacturer', 'manufacturer', typeof String),
    new ExpectedProp('manufacturer_model_name', 'manufacturerModelName', typeof String),
    new ExpectedProp('system_version', 'systemVersion', typeof String),
    new ExpectedProp('description', 'description', typeof String),
];

export const convertJsonObjectToLabeling = (labelingJsonObject: any): Labeling => {
    if (!labelingJsonObject || !_.isObject(labelingJsonObject)) {
        throw new Error('Invalid JSON object provided for Labeling conversion.');
    }

    const notFoundProps: ExpectedProp[] = [];
    for (const expectedProp of expectedLabelingProps) {
        if (!_.has(labelingJsonObject, expectedProp.jsonProp)) {
            notFoundProps.push(expectedProp);
        }
    }

    if (notFoundProps.length > 0) {
        const msg = `Expected to find following props from Labeling JSON object, but didn't: ${notFoundProps.map(p => p.jsonProp).join(', ')}.`;
        console.error(msg + ' JSON:');
        console.error(labelingJsonObject);
        throw new Error(msg);
    }

    return new Labeling(
        _.get(labelingJsonObject, 'udi', null),
        _.get(labelingJsonObject, `${expectedLabelingProps.find(e => e.modelProp === 'manufacturer')!.jsonProp}`) as string,
        _.get(labelingJsonObject, `${expectedLabelingProps.find(e => e.modelProp === 'manufacturerModelName')!.jsonProp}`) as string,
        _.get(labelingJsonObject, `${expectedLabelingProps.find(e => e.modelProp === 'systemVersion')!.jsonProp}`) as string,
        _.get(labelingJsonObject, `${expectedLabelingProps.find(e => e.modelProp === 'description')!.jsonProp}`) as string,
        labelingJsonObject
    );
}